const tugNavigatorData = [
    {
      id: 1,
      imageUrl: "https://i.ibb.co/gyfPmNT/Frame-13178-4.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 2,
      imageUrl: "https://i.ibb.co/KNHq6MM/Frame-13178-5.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 3,
      imageUrl: "https://i.ibb.co/DYdR9ts/Frame-13178-6.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 4,
      imageUrl: "https://i.ibb.co/gyfPmNT/Frame-13178-4.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 5,
      imageUrl: "https://i.ibb.co/KNHq6MM/Frame-13178-5.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 6,
      imageUrl: "https://i.ibb.co/DYdR9ts/Frame-13178-6.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 7,
      imageUrl: "https://i.ibb.co/gyfPmNT/Frame-13178-4.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 8,
      imageUrl: "https://i.ibb.co/KNHq6MM/Frame-13178-5.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
    {
      id: 9,
      imageUrl: "https://i.ibb.co/DYdR9ts/Frame-13178-6.png",
      name: "ASD Tug Navigator",
      openPort: "Name",
      openDate: "31 Aug 2023",
      rate: "$2000/Day",
      built: "undisclosed",
      dwt: "500.00 T",
    },
   
  ];
  
export default tugNavigatorData;
  